module.exports = __webpack_public_path__ + "prod/1.42.2/img/yygc.ac79602d.png";